const Copyrights = () => (
  <div>Copyright &copy; {new Date().getFullYear()} - Coben Healthcare</div>
);

export default Copyrights;
